import {Button, Grid, Link, Typography} from "@mui/material";
import Tooltip from '@mui/material/Tooltip';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import React, {useEffect, useRef, useState} from "react";
import AddOpportunityActionModal from "../../Containers/Calendar/Widgets/CalendarWidget/AddOpportunityActionModal";
import {ADD, COMPLETED_CALL, EDIT, FOLLOW_UP} from "../../Utils/constants";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {actions as contactActions, selectors as contactSelectors} from "../../../Ducks/contacts";
import {actions as opportunityActions} from "../../../Ducks/opportunity";
import {actions as eventsOverviewActions} from "../../../Ducks/eventsOverview";
import Swal from "sweetalert2";
import {Delete} from '@mui/icons-material';
import pencilEditIcon from '../../../Assets/images/pencilEditIcon.PNG';
import MakeNoteModal from "../Modals/MakeNoteModal";
import Box from '@mui/material/Box';
import moment from "moment";

function FollowUp(props) {
    const {
        person,
        jobEmail,
        followUps,
        getPersonFollowUps,
        hideTitle,
        updateFollowUpStatus,
        refreshPersonHistory,
        getPersonHistory,
        deleteFollowUp
    } = props;
    const [openAddOpportunityModal, setOpenAddOpportunityModal] = useState(false);
    const [openMakeNoteModal, setOpenMakeNoteModal] = useState(false);
    const [row, setRow] = useState(null);
    const [mode, setMode] = useState(EDIT);
    const tableRef = useRef(null);
    const [data, setData] = useState([]);
    const beautify = true;
    const editingOptions = {update: true, remove: true, missed: true, completed: true};
    const columnHeader = ["Due Time", "Calendar Invitation", "Invitation Status", "Reason", "Status", "Actions"];
    const columnKeys = ["follow_up_due_time", "event_synced", "event_status_overall", "follow_up_type", "follow_up_status", "actions"];

    useEffect(() => {

        if (person?.person_id) {
            getPersonFollowUps(person.person_id);
        }
    }, [person, getPersonFollowUps]);

    useEffect(() => {
        if (refreshPersonHistory) {
            const {person_id} = person;
            getPersonHistory({person_id: person_id, query: 'all', isNetworkDirector: false});
        }
    }, [refreshPersonHistory, person, getPersonHistory]);

    useEffect(() => {
        if (followUps) {
            const rowsToShow = followUps.map(el => {
                const o = {...el};
                // Compute actions
                o.actions = (
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-evenly'}}>
                        {editingOptions.update &&
                            <img onClick={() => handleRecordClick(el, 'update')} src={pencilEditIcon}
                                 style={{width: 22, cursor: 'pointer'}} title="Edit" alt="edit icon"/>}
                        {editingOptions.remove && <Tooltip title="Delete"><Delete color="error" sx={{fontSize: 18}}
                                                                                  onClick={() => handleRecordClick(el, 'remove')}/></Tooltip>}
                    </div>
                );

                o.follow_up_due_time = (
                    <Tooltip title="Complete/Missed Call"><Link href="#" underline="hover"
                                                                onClick={() => handleRecordClick(el, 'make_note')}> {moment(el.follow_up_due_time).format('DD/MM/YYYY HH:mm')}</Link></Tooltip>
                );
                // Compute overall status dot
                if (el.event_synced) {
                    o.event_synced = "External Invite";
                    const allAccepted = el.attendees.every(a => a.status === 'accepted');
                    const anyDeclined = el.attendees.some(a => a.status === 'declined');
                    const anyTentative = el.attendees.some(a => a.status === 'tentative');
                    let color = 'gray';

                    if (allAccepted) color = 'green';
                    else if (anyDeclined) color = '#8B0000';
                    else if (anyTentative) color = '#FFD700';
                    o.event_status_overall = (
                        <Box component="span" sx={{
                            height: 15,
                            width: 15,
                            bgcolor: color,
                            borderRadius: '50%',
                            ml: 0.4,
                            display: 'inline-block'
                        }}/>
                    );
                } else {
                    o.event_status_overall = '-';
                    o.event_synced = "Internal";
                }
                return o;
            });
            setData(rowsToShow);
        }
    }, [followUps]);

    const handleRecordClick = (el, action) => {

        if (action === 'update') {
            setRow(el);
            setMode(EDIT);
            setOpenAddOpportunityModal(true);
        } else if (action === 'remove') {
            handleDeleteFollowUpCallback(el);
        } else {
            setRow(el);
            setOpenMakeNoteModal(true);
        }
    };

    const handeFollowUpNoteSubmit = (values) => {
        updateFollowUpStatus({
            person_id: row.person_id,
            follow_up_id: row.follow_up_id,
            log_content: values.note,
            log_code: values.actionType,
            log_title: values.actionType === COMPLETED_CALL ? 'Completed Call' : 'Missed Call'
        });
    };

    const handleDeleteFollowUpCallback = (r) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'Cancel'
        })
            .then(result => result.isConfirmed && deleteFollowUp({
                person_id: r.person_id,
                follow_up_id: r.follow_up_id
            }));
    };

    const handleClose = (refresh = false) => {
        setOpenAddOpportunityModal(false);
        if (mode === ADD) setMode(EDIT);
        if (refresh) getPersonFollowUps(person.person_id);
    };

    return (
        <>  {/* Header */}
            <Grid container>
                {!hideTitle && <Grid item xs={3}><Typography variant="h6">Follow Ups</Typography></Grid>}
                <Grid item xs={hideTitle ? 12 : 9} sx={{textAlign: 'right'}}>
                    <Button variant="contained" size="small" sx={{textTransform: 'capitalize', mb: 1}} onClick={() => {
                        setOpenAddOpportunityModal(true);
                        setMode(ADD);
                        setRow(null);
                    }}>Create follow up</Button>
                </Grid>
            </Grid>

            {/* Table */}
            {data.length > 0 ? (
                <TableContainer ref={tableRef} component={Paper}>
                    <table style={{width: '100%', borderCollapse: beautify ? 'collapse' : 'separate'}}>
                        <thead>
                        <tr>{columnHeader.map(h => <th key={h} style={{
                            border: beautify ? 'none' : '1px solid #8c8c8c',
                            borderBottom: beautify ? '0.5px solid #c2c2c2' : '1px solid #8c8c8c',
                            padding: beautify ? 5 : '5px 10px',
                            fontSize: 14
                        }}>{h}</th>)}</tr>
                        </thead>
                        <tbody>
                        {data.map(rowData => (
                            <tr key={rowData.follow_up_id}>
                                {columnKeys.map(key => (
                                    <td key={key} style={{
                                        border: beautify ? 'none' : '1px solid #8c8c8c',
                                        padding: beautify ? 5 : '5px 10px',
                                        fontSize: beautify ? 13 : 14
                                    }}>
                                        {(rowData[key] && rowData[key] !== 0 ? rowData[key] : '-')}
                                    </td>
                                ))}
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </TableContainer>
            ) : (
                <Grid item xs={12} sx={{fontSize: 12, textAlign: 'center'}}>No follow ups found</Grid>
            )}

            {/* Modals */}
            <AddOpportunityActionModal open={openAddOpportunityModal} handleClose={handleClose} jobEmail={jobEmail}
                                       person={person} mode={mode} actionType={FOLLOW_UP} rescheduleFollowUp={row}/>
            <MakeNoteModal open={openMakeNoteModal} handleClose={() => {
                setOpenMakeNoteModal(false);
                setRow(null);
            }} handleSubmit={handeFollowUpNoteSubmit}/>
        </>
    );
}

const mapStateToProps = state => ({
    followUps: contactSelectors.followUps(state),
    refreshPersonHistory: contactSelectors.refreshPersonHistory(state)
});
const mapDispatchToProps = dispatch => bindActionCreators({
    getPersonFollowUps: contactActions.getPersonFollowUps,
    updateFollowUpStatus: contactActions.updateFollowUpStatus,
    deleteFollowUp: contactActions.deleteFollowUp,
    getPersonHistory: eventsOverviewActions.getPersonHistory,
    getAllEvents: opportunityActions.getAllEvents,
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(FollowUp);
